import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

export const SHOPIFY_SESSION_REFERRER_SUCCESS = 'SHOPIFY_SESSION_REFERRER_SUCCESS';
export const SHOPIFY_SESSION_REFERRER_LOADING = 'SHOPIFY_SESSION_REFERRER_LOADING';

const { ShopifySessionByReferrer: { getShopifySessionByReferrer } } = apiUrls;


export const getShopifySessionByReffererDetails = ({
  fromYear, toYear, fromMonth, toMonth
}) => async (dispatch) => {
  try {
    const { url } = getShopifySessionByReferrer
    const requestData = {
      ...getShopifySessionByReferrer,
      url,
      data: {
          fromYear,
          fromMonth,
          toYear,          
          toMonth
          }  
  };
    const data = await REQUEST(requestData);
    dispatch({
      type: SHOPIFY_SESSION_REFERRER_SUCCESS,
      data,
    })
  } catch (e) {

    dispatch({
      type: SHOPIFY_SESSION_REFERRER_SUCCESS,
      data: {
        code: "",
        modal: null,
        notifications: null,
        paginationInfo: null
      }
    })
  }

}

export const handleLoader = isLoading => (dispatch) => {
  dispatch({
    type: SHOPIFY_SESSION_REFERRER_LOADING,
    isLoading
  })
}
